// extracted by mini-css-extract-plugin
export var modal = "_iv-0";